import {configRentalcompanyManager, configUserManager} from "@/assets/plugins/mps-common/config/config-manager";

export default {
    install(Vue) {
        Vue.prototype.$configUserManager = configUserManager;
        Vue.prototype.$configRentalcompanyManager = configRentalcompanyManager;
    }
}